<template>
  <b-modal
    title="NOVO PERFIL"
    id="new_profile"
    no-close-on-backdrop
    hide-footer
    @show="evOnShow"
    @shown="evOnShown"
  >
    <b-overlay :show="loading" opacity="0.99">
      <form @submit.prevent="evOnSubmit">
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <LabelRequiredField label="Nome" />
            <input
              type="text"
              ref="autofocus"
              class="form-control"
              v-model="profile_name"
            />
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <WarningRequiredFields />
            <ErrorsMessages :errors="errors" />
          </div>
          <div
            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right"
          >
            <v-btn :disabled="loading" type="submit" class="btn-save">
              <i class="fas fa-save mr-2 text-twenty"></i>
              SALVAR
            </v-btn>
          </div>
        </div>
      </form>
    </b-overlay>
  </b-modal>
</template>

<script>
import toast from "../../lib/ToastNotification";
import api from "../../services/api";
import WarningRequiredFields from "../Components/WarningRequiredFields";
import LabelRequiredField from "../Components/LabelRequiredField";
import ErrorsMessages from "../Components/ErrorsMessages";

export default {
  name: "NewProfile",
  components: {
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
  },
  data() {
    return {
      errors: [],
      loading: false,

      profile_name: "",
    };
  },
  methods: {
    async evOnShow() {
      this.profile_name = "";
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        const params = { name: this.profile_name };
        const response = await api.post("/rest-home/profile", params);
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.$bvModal.hide("new_profile");
          toast(message, "success");
          this.$emit("created");
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style></style>
